export default async function welcome (state, appOptions, lastPage, pageOptions = {}) {
  const StaticContent = (await import(/* webpackChunkName: 'component-static-content' */ '../components/static_content')).default

  const view = new StaticContent({
    content: pageOptions.content,
    controls: ['start-using']
  })

  view.on('done', () => {
    state.changePage(lastPage)
  })

  return view
}
